export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('play-on-hover', vPlayOnHover)
})
